<template>
  <header>
    <div class="header-upper">
      <noti-partner :pHeadInfo="pHeadInfo" />
    </div>
  </header>
</template>

<script>

import notiPartner from "./Noti_partner";
// import { boardList, cashList, headerCashInfo, memberStatusList, betList } from "@/api/member.js";
import { replceDateT, numberWithCommas, getDateStr } from "@/libs/utils.js";
export default {
  name: "Header",
  components: {
    notiPartner
  },
  data() {
    return {
      localTime: "",
      pHeadInfo: {
        cashInAmt:0,
        cashOutAmt:0,
        cashInCnt:0,
        cashOutCnt:0,
        ptAdd:0,
        ptAddApply:0,
        ptChange:0,
        ptChangeApply:0,
        allAmt:0,
        yallAmt:0,
        beneAmt:0
      }
    };
  },
  methods: {
    getTime() {
      const time = new Date();
      const dateFormat = "yyyy-MM-dd HH:mm";
      this.localTime = getDateStr(time, dateFormat);
    },
    async getInToday() {
      const reqData = {
        startDate: new Date(),
        endDate: new Date(),
        cashType: "in",
        cashStatus: "1"
      };
      const dateFormat = "yyyy-MM-dd";
      reqData.startDate = getDateStr(reqData.startDate, dateFormat);
      reqData.endDate = getDateStr(reqData.endDate, dateFormat);

      const res = await cashList(reqData);
      const totalData = res.data.pageInfo;
      if (res.data.list.length != 0) {
        this.pHeadInfo.inToday = numberWithCommas(totalData.tatal_list_count);
      } else {
        this.pHeadInfo.inToday = 0;
      }
    },
    async getOutToday() {
      const reqData = {
        startDate: new Date(),
        endDate: new Date(),
        cashType: "out",
        cashStatus: "1"
      };
      const dateFormat = "yyyy-MM-dd";
      reqData.startDate = getDateStr(reqData.startDate, dateFormat);
      reqData.endDate = getDateStr(reqData.endDate, dateFormat);
      const res = await cashList(reqData);
      const totalData = res.data.pageInfo;
      if (res.data.list.length != 0) {
        this.pHeadInfo.outToday = numberWithCommas(totalData.tatal_list_count);
      } else {
        this.pHeadInfo.outToday = 0;
      }
    },
    IntervalCollector() {
      setInterval(() => {
      }, 3000);
    }
  },
  created() {
  }
};
</script>

<style scoped>
.header-upper,
.header-lower {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  /* height: 60px; */
}
.header-upper {
  padding: 6px 6px;
  background-image: linear-gradient(90deg, #126ae2 0%, #0c4695 100%);
}
.header-lower {
  padding: 8px 0;
}
.logo {
  font-size: 1.35em;
  font-weight: 800;
  width: 220px;
  padding-left: 15px;
  box-sizing: border-box;
}
.logo a {
  color: #fff;
}
.langs-wrap {
  display: flex;
  justify-content: space-between;
  align-content: center;
  color: #fff;
}
.langs-wrap .title {
  font-weight: 700;
  margin-right: 6px;
  font-size: 0.875em;
}
.selLang {
  height: 18px;
}
.credit-wrap {
  width: 220px;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  box-sizing: border-box;
}
.credit-wrap .title {
  font-weight: 800;
  color: #18698b;
}
.credit-wrap .content-val {
  font-weight: 800;
  color: #212121;
}
</style>
